<div class="line-chart" style="position: relative" [style.width]="width" [style.height]="height + 'px'" *ngIf="width">
  <canvas id="lineChart{{id}}" [style.width]="width"></canvas>
</div>
